import { useEffect, useState } from 'react';
import bamoaLogo from '@/assets/bamoa-logo.jpg';
import { useUIStore } from '@/state/store';
import { apiFetch } from '@/lib/auth';

export function Rail() {
  const setView = useUIStore((s) => s.setView);
  const view = useUIStore((s) => s.view);
  const [pending, setPending] = useState(0);

  useEffect(() => {
    let alive = true;
    apiFetch('/api/calls/pending-wrapup')
      .then((r) => (r.ok ? r.json() : []))
      .then((x) => { if (alive && Array.isArray(x)) setPending(x.filter((c: any) => !c.wrapDone).length); })
      .catch(() => { /* */ });
    return () => { alive = false; };
  }, [view]);
  return (
    <aside className="rail">
      <img src={bamoaLogo} alt="Bamoa" className="rail-logo" />
      <div className="rail-spacer"></div>
      <div className="rail-bottom">
        <button
          className="rail-btn"
          title="Nachbearbeitung"
          onClick={() => setView(view === 'wrapup' ? 'dashboard' : 'wrapup')}
          style={view === 'wrapup' ? { color: 'var(--tenant-accent)', background: 'var(--bg-elev-2)' } : undefined}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2" />
            <rect x="8" y="2" width="8" height="4" rx="1" />
            <path d="m9 14 2 2 4-4" />
          </svg>
          {pending > 0 && <span className="rail-badge">{pending > 9 ? '9+' : pending}</span>}
        </button>
        <button
          className="rail-btn"
          title="Experten-Links verwalten"
          onClick={() => setView(view === 'links' ? 'dashboard' : 'links')}
          style={view === 'links' ? { color: 'var(--tenant-accent)', background: 'var(--bg-elev-2)' } : undefined}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
          </svg>
        </button>
      </div>
    </aside>
  );
}
